export const PACK_OPENING_FAQ = [
  {
    q: "How many cards are in a Palworld booster pack?",
    a: "Every Palworld Official Card Game booster pack from Dawn of Palpagos (EBP01) contains 7 cards: four Commons, two Uncommons and one hit slot that holds an R or better, including parallel rare treatments.",
  },
  {
    q: "How do I open free Palworld card packs online?",
    a: "Open the Pal Stars pack simulator, tear the pack and flip through the cards. Guests get a free demo booster, and a free Pal Stars account unlocks 5 openings every day plus a permanent collection of everything you pull.",
  },
  {
    q: "Can I open a Palworld trial deck instead of a booster pack?",
    a: "Yes. Account holders choose between Booster Pack \"Dawn of Palpagos\", the Trial Deck \"Dawn of Palpagos Red・Blue\" and the Trial Deck \"Dawn of Palpagos Green・Purple\". Each opening counts as one of your 12 free daily packs.",
  },
  {
    q: "What are the Palworld TCG pull rates?",
    a: "In the hit slot, R lands about 60.8% of packs, RR about 20%, SR 10%, SP 5%, OSR (Over Super Rare) 2.5%, SSP 1.2% and SSS Ultra Secret Gold about 0.5%.",
  },
  {
    q: "How does the card grading score work?",
    a: "Each pulled card is graded like a real submission: centering, corners, edges and surface each get a sub-grade, the weakest sub-grade is weighted heaviest, and listed defects explain the score. A flawless Gem Mint 10 lands on roughly 1.2% of pulls.",
  },
  {
    q: "Can I trade Palworld cards with other players on Pal Stars?",
    a: "Yes. Account holders appear on the daily top-pull board, and you can send a trade offer on any card someone else pulled today straight from that board.",
  },

];
